import { RsuiteTooltipWrapper } from '@/widgets/components/tooltips';
import React from 'react';
import { cssVars } from '../../../app/styles';
import { SpaceFiller } from './styles';

const labelsByBookingStatus = {
  bookable: 'Available',
  booked: 'Booked',
  blocked: 'Blocked',
  unbookable: 'Unbookable',
  unknown: 'Booking status unknown',
};

function getLabelForActivity(activity, monthName) {
  let bookedOnMessage = '';
  if (activity.status === 'booked') {
    bookedOnMessage = activity.bbDate ? `on ${activity.bbDate} ` : '';
    bookedOnMessage += 'for ';
  }
  const statusLabel = labelsByBookingStatus[activity.status] || activity.status;
  const { startDay, endDay } = activity;
  const dayLabel = startDay === endDay ? startDay : `${startDay} - ${endDay}`;

  return `${statusLabel} ${bookedOnMessage} ${monthName} ${dayLabel}`;
}

function coalesceListingAcvititiesByBookingDate(calendarActivity) {
  let prevActivity = null;
  const coalescedActivities = [];

  calendarActivity.forEach((activity, i) => {
    const day = i + 1;
    const { bbDate, status } = activity;
    if (bbDate !== prevActivity?.bbDate || status !== prevActivity?.status) {
      coalescedActivities.push({
        bbDate,
        status,
        startDay: day,
        endDay: day,
        activities: [activity],
      });
    } else {
      const lastCoalescedActivity =
        coalescedActivities[coalescedActivities.length - 1];
      lastCoalescedActivity.activities.push(activity);
      lastCoalescedActivity.endDay = day;
    }

    prevActivity = activity;
  });

  return coalescedActivities;
}

const { normal, light } = cssVars.color.calendarColor;

const allBookedColors = [normal, light];

function getActivityStatusColor(activity) {
  if (activity.status === 'booked') {
    // console.log('checkinid', activity.checkInId);
    return allBookedColors[activity.checkInId % allBookedColors.length];
  }

  if (activity.status === 'bookable') {
    return cssVars.propertyHistoryColors.availableColor;
  }
  return cssVars.propertyHistoryColors.unbookableColor;
}

export function listingCalendarActivityToBookingEvents(
  calendarActivities,
  monthName
) {
  const coalescedActivities =
    coalesceListingAcvititiesByBookingDate(calendarActivities);
  const bookingEvents = coalescedActivities.map((activity) => ({
    ...activity,
    style: { background: getActivityStatusColor(activity.activities[0]) },
    contents: (
      <RsuiteTooltipWrapper
        text={getLabelForActivity(activity, monthName)}
        tooltipPosition={'bottom'}
      >
        <SpaceFiller />
      </RsuiteTooltipWrapper>
    ),
  }));

  return bookingEvents;
}
